import axios from "axios";

import { apiDomain } from "../../store/constants";

const USPExtend = {
  index(params) {
    return axios({
      url: apiDomain + `api/pending-group`,
      method: "GET",
      params: params,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },

  show(id) {
    return axios({
      url: apiDomain + `api/pending-group/${id}`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },

  create(params) {
    return axios({
      url: apiDomain + `api/pending-group/create`,
      method: "GET",
      params: params,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },

  createPendingGroup(form_a_id) {
    return axios({
      url: apiDomain + `api/create-pending-group?form_a_id=${form_a_id}`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },

  store(data) {
    // data.files = JSON.stringify(data.files);
    return axios({
      url: apiDomain + `api/pending-group`,
      method: "POST",
      data: data,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },

  edit(data) {
    return axios({
      url: apiDomain + `api/pending-group/${data.id}/edit`,
      method: "GET",
      params: data,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },

  update(payload) {
    console.log(payload);
    return axios({
      url: apiDomain + `api/pending-group/${payload.id}`,
      method: "PUT",
      data: payload.data,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },

  delete(id) {
    return axios({
      url: apiDomain + `api/pending-group/${id}`,
      method: "DELETE",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
};

export default USPExtend;
